import { render, staticRenderFns } from "./StammdatenImportPage.vue?vue&type=template&id=59bc23ae&scoped=true"
import script from "./StammdatenImportPage.vue?vue&type=script&lang=js"
export * from "./StammdatenImportPage.vue?vue&type=script&lang=js"
import style0 from "./StammdatenImportPage.vue?vue&type=style&index=0&id=59bc23ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc23ae",
  null
  
)

export default component.exports